import React, { Dispatch, SetStateAction } from 'react'
import {
  formatEndDate,
  formatPickupDate,
} from '@components/Details/AuctionDetailInfo'
import getEasternTimezone from '@utilities/functions/getEasternTimezone'
import BidCountdown from '@components/BidCountdown/BidCountdown'
import BackToItemList from '@components/Details/BackToItemList'
import BidButton from '../../../../elements/BidButton/BidButton'
import { C } from '@components/MainLayout/reusable/helpers'
import BidSocialIcons from '@components/BidSocialIcons/BidSocialIcons'
import { useItemPage } from '@components/ItemPage/Layout/ItemPageContext'
import OutsideClickAlerter from '@components/OutsideClickAlerter/OutsideClickAlerter'

const AuctionInfo = ({
  showMobileInfo,
  setShowMobileInfo,
}: {
  showMobileInfo: boolean
  setShowMobileInfo: Dispatch<SetStateAction<boolean>>
}) => {
  const {
    auction,
    itemState: { id: itemId, itemClosed },
    pageNumber,
    setInfoSlideOutOpen,
  } = useItemPage()

  const {
    location: { address, city, state, zip },
    utcEndDateTime,
    auctionPickupDates,
    endTimeText,
  } = auction

  if (!showMobileInfo) return <></>

  return (
    <OutsideClickAlerter
      callback={() => {
        setShowMobileInfo(false)
      }}
      className="relative"
    >
      <div className="border-4 absolute w-full grid grid-cols-2 md:grid-cols-3 text-xs border-bidfta-gray-border bg-white z-40">
        <div className="px-4 py-3 flex flex-col md:justify-center md:items-center border-r md:border-b border-bidfta-gray-border">
          <div className="flex flex-col justify-center md:w-40">
            <h4 className="font-bold text-sm leading-tight uppercase mb-1">
              Location:
            </h4>
            <p>{address}</p>
            <p>
              {city}, {state} {zip}
            </p>
          </div>
        </div>
        <div className="px-4 py-3 flex flex-col md:justify-center md:items-center md:border-r md:border-b border-bidfta-gray-border">
          <div className="flex flex-col justify-center md:w-40">
            <h4 className="font-bold text-sm leading-tight uppercase mb-1">
              Pick Up Dates:
            </h4>
            <h4 className="font-bold text-sm leading-tight uppercase mb-1">
              (Local Times)
            </h4>
            {auctionPickupDates.map((pickupDate: any, i: any) => (
              <div
                className={`py-1 border-bidfta-gray-border ${
                  auctionPickupDates.length !== i + 1 ? 'xl:border-b' : ''
                }`}
                key={pickupDate.id}
              >
                <p className="font-semibold pb-1">
                  {formatPickupDate(pickupDate.pickupStartTime)}
                </p>
                <span className="text-10">
                  {pickupDate.pickupStartTimeText} -{' '}
                  {pickupDate.pickupEndTimeText}
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className="px-4 py-3 flex flex-col md:justify-center md:items-center border-r md:border-r-0 border-t md:border-t-0 border-b border-bidfta-gray-border">
          <div className="flex flex-col justify-center md:w-40">
            <h4 className="font-bold text-sm leading-tight uppercase mb-1">
              Auction End Date:
            </h4>
            <div className="mb-1">
              <p>
                {formatEndDate(getEasternTimezone(new Date(utcEndDateTime)))}
              </p>
              <span>{endTimeText} EST</span>
            </div>
            <BidCountdown
              date={utcEndDateTime}
              hideClock
              itemClosed={itemClosed}
            />
          </div>
        </div>
        <div className="w-full px-4 py-3 flex flex-col justify-center border-t border-b md:border-r md:border-b-0 md:border-t-0 border-bidfta-gray-border gap-2">
          <BackToItemList
            auctionId={auction.id}
            pageNumber={pageNumber}
            itemId={itemId}
          />

          <div className="w-full">
            <BidButton
              label="More Info"
              theme="blue-light"
              callBack={() => setInfoSlideOutOpen(true)}
              width="full"
              buttonStyle="hollow"
            />
          </div>
        </div>
        <div className="px-4 py-7 flex flex-col md:justify-center md:items-center border-r border-bidfta-gray-border">
          <div className="flex flex-col justify-center md:w-40">
            <h4 className="font-bold text-sm leading-tight uppercase mb-1">
              Questions?
            </h4>
            <a
              href={C.AUCTION_CONTACT}
              className="text-bidfta-blue-light underline font-semibold"
            >
              Contact Us Here
            </a>
          </div>
        </div>
        <div className="px-4 py-7 flex flex-col md:justify-center md:items-center">
          <div className="flex flex-col justify-center md:w-40">
            <span className="mb-2 block">Share Auction:</span>
            <div className="flex">
              <BidSocialIcons />
            </div>
          </div>
        </div>
      </div>
    </OutsideClickAlerter>
  )
}

export default AuctionInfo
